// Thin wrapper over the session roles context (#13).
import { useRoles } from './roles/RolesContext';
import { selectDocumentAccess } from './roles/deriveRoles';

interface UseDocumentAccessResult {
  canAccessDocuments: boolean;
  loading: boolean;
}

export function useDocumentAccess(): UseDocumentAccessResult {
  const roles = useRoles();
  return { ...selectDocumentAccess(roles), loading: roles.loading };
}

export default useDocumentAccess;
